<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { categories_path } from "../../../../path";
import add from "./add.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    add: add,
    EditIcon,
    DeleteIcon,
  },
  data() {
    return {
      title: "Categories",
      items: [
        {
          text: "List",
        },
        {
          text: "Category",
          active: true,
        },
      ],
      selectedCategory: {},
      categories: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      filter: [],
      fields: ["name", "description", "parent_category", "Actions"],
      currentPage: 2,
      key: 0,
    };
  },
  watch: {
    currentPage() {
      this.getCategories();
    },
  },
  methods: {
    async getCategories() {
      try {
        let response = await axios.get(
          this.base_url + categories_path.LIST_CATEGORY,
          {
            params: { page: this.currentPage },
          }
        );
        if (response.data.status == true) {
          this.categories = response.data.data;
          this.key += 1;
        }
      } catch (e) {
        console.log(e);
      }
    },
    reload() {
      this.getCategories();
    },
    setEdit(d) {
      console.log(d, "ssss");
      this.selectedCategory = d;
      this.$bvModal.show("bv-add-category");
    },
    async deleteData(d) {
      try {
        let response = await axios.delete(
          this.base_url + categories_path.DELETE_CATEGORY + "/" + d.id
        );
        if (response.data.status == true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: `Category Deleted`,
            variant: "success",
            solid: true,
          });
          this.getCategories();
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button
                  @click="$bvModal.show('bv-add-category')"
                  class="btn btn-primary mb-10 pb-10 shadow-lg"
                  style="border-radius: 12px"
                  >Add Category</b-button
                >
                <b-modal
                  id="bv-add-category"
                  :title="
                    (Object.keys(selectedCategory).length > 0
                      ? 'Edit'
                      : 'Add') + 'Category'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selectedCategory="selectedCategory"
                  ></add>
                </b-modal>
              </div>
              <!-- Search -->
              <!--              <div class="col-sm-12 col-md-6">-->
              <!--                <div id="tickets-table_filter" class="dataTables_filter text-md-right">-->
              <!--                  <label class="d-inline-flex align-items-center mr-5">-->
              <!--                    Search:-->
              <!--                    <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input>-->
              <!--                    &lt;!&ndash; <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> &ndash;&gt;-->
              <!--                  </label>-->
              <!--                </div>-->
              <!--              </div>-->

              <!-- End search -->
            </div>
            <div class="table-responsive mb-0" :key="key">
              <b-table
                :key="key"
                :items="categories.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(parent_category)="row">
                  {{
                    row.item.main_category ? row.item.main_category.name : ""
                  }}
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="setEdit(row.item)">
                      <EditIcon />
                    </div>
                    <div @click="deleteData(row.item)">
                      <DeleteIcon />
                    </div>
                  </div>
                  <!-- <b-button
                    @click="setEdit(row.item)"
                    variant="primary"
                    style="border-radius: 50%"
                  >
                    <i class="fa fa-pen"></i>
                  </b-button> -->
                  <!-- <b-button
                    @click="deleteData(row.item)"
                    variant="danger"
                    class="ml-1"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button> -->
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="categories.key"
                      v-model="currentPage"
                      :total-rows="categories.total"
                      :per-page="categories.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style></style>
